import React, { useEffect, useState } from 'react';
import './Navibar.css'
import AccountPopover from './AccountPopover';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { baseURL } from '../pages/backend_url';

import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default function Navibar({ setLoginSuccess, drawerNavigation = false, onNavigationToggle }) {
  const [notiCount, setNotiCount] = useState(0)
  const loggedInUser = sessionStorage.getItem("user_token");
  const foundUser = JSON.parse(loggedInUser);

  useEffect(() => {
    if (foundUser.role_capabilities?.all_modules_access !== true && foundUser.account_id) {
      const getEnreadMsgCount = () => {
        axios.get(baseURL + "/combined_unread_msg_count/" + foundUser.userEmail, {
          params: { companyNumber: foundUser.account_id.toString() }
        })
          .then((res) => {
            setNotiCount(res.data);
          })
      }
      // Set up an interval to run the function every 120 seconds
      const intervalId = setInterval(getEnreadMsgCount, 120000);
      // Clean up the interval when the component is unmounted
      return () => clearInterval(intervalId);
    }
  }, [
    foundUser.account_id,
    foundUser.role_capabilities?.all_modules_access,
    foundUser.userEmail,
  ])
  function notificationsLabel(count) {
    if (count === 0) {
      return 'no notifications';
    }
    if (count > 100) {
      return 'more than 100 notifications';
    }
    return `${count} notifications`;
  }

  return (
    <nav className="navbar navibar" aria-label="Application header">
      <div className="container-fluid navibarContainer">
        <div className="navibarLeading">
          {drawerNavigation && (
            <button
              type="button"
              className="navibarMenuButton"
              aria-label="Close navigation"
              aria-controls="mvp-primary-navigation"
              aria-expanded="true"
              onClick={onNavigationToggle}
            >
              <CloseRoundedIcon />
            </button>
          )}

          <Link className="portalBrand" to="/" aria-label="Manual Vendor Portal home">
            <span className="portalBrandMark" aria-hidden="true">MV</span>
            <span className="portalBrandCopy">
              <span className="portalBrandName">Manual Vendor</span>
              <span className="portalBrandDescriptor">Portal</span>
            </span>
          </Link>
        </div>

        <div className="navibarActions">
          <div className="navibarWorkspace" aria-label="Current workspace">
            <span className="navibarWorkspaceLabel">
              {foundUser.role_capabilities?.all_modules_access === true ? 'Administration' : 'Vendor workspace'}
            </span>
            {foundUser.account_id && (
              <span className="navibarCompanyNumber">#{foundUser.account_id}</span>
            )}
          </div>

          <Link className="navibarNotificationLink" to="/SupportScreen">
            <IconButton
              className="navibarIconButton"
              aria-label={notificationsLabel(notiCount)}
              title="Support notifications"
            >
              <Badge badgeContent={notiCount} color="error" max={99}>
                <NotificationsNoneIcon />
              </Badge>
            </IconButton>
          </Link>

          <span className="navibarDivider" aria-hidden="true" />
          <AccountPopover setLoginSuccess={setLoginSuccess} />
        </div>
      </div>
    </nav>
  )
}
